import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Event } from './../../../classes/classes';
import { EventsService } from './../../../services/events.service';

@Component({
  selector: 'app-event-view',
  templateUrl: './event-view.component.html',
  styleUrls: ['./event-view.component.sass']
})
export class EventViewComponent implements OnInit {

  public event: Event;

  constructor(
    private _route: ActivatedRoute,
    private _service: EventsService) { }

  ngOnInit() {
    this.event = this._service.get_events().find((e: Event) => e.url == this._route.snapshot.url[1].path);
  }

  public backFn(): void {
    history.back();
  }

}
